import { useTheme } from '@mui/material';
import { addOpacityToThemeColor } from 'utils/styles/addOpacity';

export const IdentityStepTypeIdIcon = () => {
    const theme = useTheme();
    const mainColour = theme.colors.other.icon.stroke.primary;
    const transparentColour = addOpacityToThemeColor(mainColour, 0.2);
    const borderColour = theme.colors.other.icon.background.primary;

    return (
        <svg
            width="176"
            height="124"
            viewBox="0 0 176 124"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M24 0.5H138.524C148.723 0.5 157.758 7.07881 160.889 16.7854L173.147 54.7854C174.66 59.4761 174.66 64.5239 173.147 69.2146L160.889 107.215C157.758 116.921 148.723 123.5 138.524 123.5H24C11.0213 123.5 0.5 112.979 0.5 100V24C0.5 11.0213 11.0213 0.5 24 0.5Z"
                fill="white"
                stroke="url(#linear1)"
            />
            <g opacity="0.05">
                <path
                    d="M92.2334 25.7238C99.5967 29.9877 105.236 36.6513 103.869 41.0444C102.45 45.3512 94.0603 47.2506 86.4599 52.2799C78.809 57.2229 71.9983 65.3822 65.7129 64.5429C59.4633 63.5668 53.7034 53.729 53.9404 44.4358C54.2637 35.092 60.6345 26.3792 68.3381 22.9117C76.0923 19.5305 84.9563 21.4094 92.2334 25.7238Z"
                    fill={transparentColour}
                />
                <path
                    d="M92.2334 25.7238C99.5967 29.9877 105.236 36.6513 103.869 41.0444C102.45 45.3512 94.0603 47.2506 86.4599 52.2799C78.809 57.2229 71.9983 65.3822 65.7129 64.5429C59.4633 63.5668 53.7034 53.729 53.9404 44.4358C54.2637 35.092 60.6345 26.3792 68.3381 22.9117C76.0923 19.5305 84.9563 21.4094 92.2334 25.7238Z"
                    fill={mainColour}
                />
            </g>
            <rect
                x="40.5"
                y="33.5"
                width="76"
                height="15"
                rx="1.5"
                fill="white"
                stroke={mainColour}
            />
            <rect
                opacity="0.89"
                x="44"
                y="39"
                width="39"
                height="4"
                rx="1"
                fill={transparentColour}
            />
            <path
                d="M101.873 50.7793L101.873 50.7791L87.8741 40.7801C87.8739 40.7799 87.8736 40.7797 87.8734 40.7795C87.6372 40.6099 87.3567 40.5126 87.0661 40.4996C86.7752 40.4866 86.4869 40.5585 86.2362 40.7067C85.9856 40.8548 85.7835 41.0728 85.6547 41.3339C85.526 41.5947 85.476 41.8874 85.5107 42.1761C85.5108 42.1764 85.5108 42.1767 85.5108 42.177L87.5106 59.1754L87.5107 59.1757C87.5452 59.468 87.665 59.7437 87.8551 59.9685C88.0452 60.1932 88.2973 60.357 88.5799 60.4396C88.8624 60.5221 89.163 60.5196 89.4442 60.4325C89.7254 60.3454 89.9747 60.1775 90.1612 59.9497L90.1613 59.9496L93.3296 56.076L96.338 60.94L96.601 61.3652L97.0262 61.1023L98.7272 60.0503L99.1525 59.7873L98.8895 59.362L95.911 54.5461L101.292 53.4697C101.293 53.4696 101.293 53.4695 101.293 53.4695C101.58 53.413 101.845 53.2736 102.053 53.0685C102.262 52.8633 102.406 52.6014 102.467 52.3153C102.529 52.0292 102.505 51.7314 102.4 51.4585C102.294 51.1855 102.111 50.9494 101.873 50.7793Z"
                fill={mainColour}
                stroke="white"
            />
            <path
                d="M109.924 43.0716C109.728 43.3849 109.272 43.3849 109.076 43.0716L107.478 40.515C107.27 40.182 107.509 39.75 107.902 39.75L111.098 39.75C111.491 39.75 111.73 40.182 111.522 40.515L109.924 43.0716Z"
                fill={mainColour}
            />
            <defs>
                <linearGradient
                    id="linear1"
                    x1="88"
                    y1="0"
                    x2="88"
                    y2="124"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.6" stopColor={borderColour} />
                    <stop offset="1" stopColor="#ffffff" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
